export default __webpack_public_path__ + "static/media/gps.f2af8e86.svg";